import { useState } from 'react';
import axios from 'axios';
import { message } from 'antd';
import I18n from 'i18n-js';
import {
  close_ticket_path as closeTicketPath,
  reopen_ticket_path as reopenTicketPath,
} from 'js-routes/generated/routes';

const DECISION_PATHS = {
  close: closeTicketPath,
  reopen: reopenTicketPath,
};

const useReviewDecision = ({
  form,
  ticketId,
  setInitialTickets,
  handleError,
}) => {
  const [isDecisionSending, setIsDecisionSending] = useState(false);

  const submitDecision = async (decision) => {
    setIsDecisionSending(true);

    try {
      const { data } = await axios({
        headers: { Accept: 'application/json, text/javascript' },
        responseType: 'json',
        method: 'patch',
        url: DECISION_PATHS[decision](ticketId),
      });

      form.setFieldValue('status', data.ticketStatus);
      setInitialTickets(data.filteredTickets);
      message.success(I18n.t('flash.tickets.updated'));
    } catch (error) {
      handleError(error);
    } finally {
      setIsDecisionSending(false);
    }
  };

  return { isDecisionSending, submitDecision };
};

export default useReviewDecision;
